<template>
  <div class="legal-page">
    <div class="legal-container">
      <div class="breadcrumb-bar">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="sep">/</span>
        <span class="crumb-current">版权声明</span>
      </div>

      <h1 class="legal-title">辰鳗科技集团有限公司官方网站版权声明</h1>
      <p class="legal-updated">生效日期：2026年8月27日　　更新日期：2026年8月24日</p>

      <section class="legal-section">
        <p class="legal-intro"><strong>引言</strong></p>
        <p>
          本网站（域名：www.smalleel.com）由辰鳗科技集团有限公司（以下简称"我们""本公司"）运营管理。为保护本公司及相关权利人的合法权益，规范本网站内容的使用，明确双方权利义务，特制定本声明。
        </p>
        <p>
          请您在访问、浏览、使用本网站前仔细阅读本声明全部内容。您一旦访问、浏览或使用本网站，即视为您已充分理解并同意本声明的全部条款；如您不同意本声明的任何内容，请立即停止访问和使用本网站。
        </p>
      </section>

      <section class="legal-section">
        <h2>一、权利归属</h2>
        <p>
          1.1
          本网站的全部内容，包括但不限于文字、图片、图表、图标、标识、视频、音频、动画、页面设计、版式编排、界面布局、程序代码、数据库、技术文档、白皮书、产品说明、解决方案、项目案例及其汇编，均受《中华人民共和国著作权法》《中华人民共和国商标法》《中华人民共和国专利法》《中华人民共和国反不正当竞争法》等法律法规保护，其著作权及其他相关权利归本公司或相关权利人所有。
        </p>
        <p>
          1.2
          <strong>商标权：</strong
          >本网站使用的"辰鳗""SMALLEEL"及本公司相关图形标识、企业标识，均为本公司享有权利的商标或商业标识。未经本公司书面许可，任何单位或个人不得以任何方式使用、复制、修改上述标识，不得将其或与之近似的标识用于商品、服务、企业名称、域名、应用名称或社交媒体账号，不得实施可能导致相关公众混淆误认的行为。
        </p>
        <p>
          1.3
          <strong>专利与技术成果：</strong
          >本网站展示的产品、系统、装置、方法及技术方案，可能涉及本公司已获授权或已申请的发明专利、实用新型专利、外观设计专利，以及计算机软件著作权、集成电路布图设计等权利。展示行为不构成对任何第三方的许可。
        </p>
        <p>
          1.4
          <strong>软件权利：</strong
          >本公司能源管理SaaS平台、物联网终端软件及配套系统的相关权利归本公司所有。未经书面授权，任何单位或个人不得对相关软件、接口、页面进行复制、反向工程、反向编译、反向汇编，或以其他方式获取源代码、接口协议、算法逻辑。
        </p>
        <p>
          1.5
          <strong>第三方素材：</strong
          >本网站使用的第三方图片、字体、插件、开源组件等素材，我们已尽合理注意义务取得合法授权或遵循相应开源许可。如相关权利人认为存在侵权情形，请按本声明第六条的方式与我们联系，我们将在核实后及时处理。
        </p>
      </section>

      <section class="legal-section">
        <h2>二、授权使用与合理引用</h2>
        <p>
          2.1
          在遵守本声明的前提下，我们许可您为个人学习、研究或者欣赏等非商业目的，浏览、下载或打印本网站的公开内容，但您不得删除、遮蔽或改变其中的商标、标识、署名及权利声明。
        </p>
        <p>
          2.2
          新闻媒体、行业机构及合作伙伴转载本网站内容的，应当同时满足下列条件：（1）注明来源为"辰鳗科技集团有限公司官网"并保留可访问的原文链接；（2）保持内容完整、准确，不得断章取义、删改或者歪曲原意；（3）不得用于与本公司业务相竞争、或者可能损害本公司商业信誉与商品声誉的用途。
        </p>
        <p>
          2.3
          超出前述范围的使用，包括但不限于将本网站内容用于商业宣传、盈利性活动、招投标材料、产品资料、培训课程或者对外销售的，均须事先取得本公司书面许可。
        </p>
        <p>
          2.4
          本网站发布的白皮书、案例、技术资料仅供参考，不构成对任何具体项目的技术承诺或商业保证。
        </p>
      </section>

      <section class="legal-section">
        <h2>三、搜索引擎与人工智能服务的内容使用</h2>
        <p>
          3.1
          我们欢迎搜索引擎、生成式人工智能（AI）服务、知识问答与信息聚合服务，在遵守本声明及本网站robots.txt协议的前提下，抓取、索引、摘要并引用本网站的公开内容，用于向用户提供检索结果、答复或摘要。
        </p>
        <p>
          3.2
          前述使用应当符合下列要求：（1）注明来源为"辰鳗科技集团有限公司官网"，并在技术条件允许时保留可访问的原文链接；（2）准确反映原文含义，不得篡改、歪曲或者与本公司无关的信息相混同；（3）不得删除或遮蔽本公司的商标、标识及权利声明；（4）不得生成足以使公众误认为经本公司认可、授权或者与本公司存在关联关系的内容。
        </p>
        <p>
          3.3
          未经本公司书面许可，不得实施下列行为：（1）以爬虫、镜像、批量抓取等方式系统性地复制本网站全部或者实质性部分内容，或者据此建立与本网站内容实质性相同的数据库、镜像站点；（2）以超出正常访问所必需的频率访问本网站，影响本网站正常运行；（3）将本网站内容用于训练、微调可能实质性替代本网站内容或者本公司产品与服务的商业模型（如有此类需求，请按本声明第十条联系我们协商授权）。
        </p>
        <p>
          3.4
          第三方搜索引擎、人工智能服务基于本网站内容生成的答复、摘要、评价或者推荐，系该第三方独立生成，不构成本公司的陈述、承诺、要约或者担保。以本公司官方网站及正式签署的书面文件为准。
        </p>
      </section>

      <section class="legal-section">
        <h2>四、网站使用规范</h2>
        <p>
          4.1
          您在访问、使用本网站时，应当遵守法律法规和公序良俗，不得利用本网站从事任何违法违规活动，包括但不限于发布违法信息、传播不良内容、恶意攻击本网站或其服务器、非法侵入或干扰本网站系统、窃取或盗用本网站数据、侵害他人合法权益等。
        </p>
        <p>
          4.2
          您应妥善保管在本网站注册的账号及密码（如有）。因您自身保管不当、主动向他人披露或者其他归因于您的原因导致的损失，由您自行承担。
        </p>
        <p>
          4.3
          您在本网站发布或提交的内容（如有相应权限），应当保证真实、合法、有效，不得含有虚假信息、侵权内容或者违法违规内容。您发布或提交的内容侵害他人权益或者违反法律法规的，您应承担由此产生的全部责任；给本公司造成损失的，本公司有权向您追偿，并有权删除相关内容、暂停或终止向您提供相关服务。
        </p>
      </section>

      <section class="legal-section">
        <h2>五、禁止行为</h2>
        <p>
          未经本公司书面许可，任何单位或个人不得实施下列行为：（1）以本公司或其关联公司名义对外发布信息、开展经营活动、签署文件；（2）注册、使用与本公司商标、字号相同或近似的域名、企业名称、应用名称、社交媒体账号；（3）伪造、变造本公司的授权文件、资质证书、检测报告、合同文本或印章；（4）虚构与本公司的合作关系、代理关系或者项目业绩；（5）其他侵害本公司知识产权、商业信誉或者构成不正当竞争的行为。
        </p>
      </section>

      <section class="legal-section">
        <h2>六、侵权通知与处理</h2>
        <p>
          6.1
          如您认为本网站的内容侵害了您的合法权益，请通过本声明第十条载明的方式向我们发送书面通知，并提供下列材料：（1）权利人的姓名或名称、联系方式和地址；（2）权属证明材料；（3）要求采取必要措施的内容所在的网络地址或者足以准确定位侵权内容的相关信息；（4）构成侵权的初步证据；（5）通知真实性的书面保证。
        </p>
        <p>
          6.2
          我们收到符合前款要求的通知后，将及时核实并依法采取删除、屏蔽、断开链接等必要措施，并将通知转送相关内容提供者。
        </p>
        <p>6.3 通知人因错误通知造成本公司或者他人损害的，应当依法承担相应责任。</p>
        <p>
          6.4
          如您认为被处理的内容不构成侵权，可以向我们提交不侵权的书面说明及初步证据，我们将依照《中华人民共和国民法典》及相关规定处理。
        </p>
      </section>

      <section class="legal-section">
        <h2>七、免责声明</h2>
        <p>
          7.1
          本网站力求内容准确、完整、及时，但不保证全部内容不存在错误或遗漏，亦不保证内容的实时性。产品与服务的具体技术参数、性能指标、价格及交付条件，以双方正式签署的书面合同约定为准。
        </p>
        <p>
          7.2 本网站展示的产品、服务、方案、价格及案例信息属于要约邀请，不构成要约或承诺。
        </p>
        <p>
          7.3
          本网站可能包含前瞻性表述（如技术路线、市场判断、发展规划等），该等表述基于发布时的信息作出，可能因政策、市场及技术变化而调整，不构成对未来业绩或结果的保证。
        </p>
        <p>
          7.4
          本网站可能包含第三方链接。第三方网站的内容、隐私政策与运营行为均由该第三方独立负责，我们不对其内容的真实性、合法性承担责任。
        </p>
        <p>
          7.5
          因不可抗力（如地震、洪水、台风、疫情、战争等）、政府行为、电信或网络运营商故障、黑客攻击、第三方服务中断等非归因于本公司的原因，导致本网站无法正常访问或者您无法正常使用本网站服务的，在法律允许的范围内，本公司不承担责任。
        </p>
        <p>
          7.6
          在法律允许的最大范围内，本公司不对您因使用或不能使用本网站而产生的间接损失、利润损失或者商誉损失承担责任。本条不适用于依照法律规定不得免除的责任。
        </p>
      </section>

      <section class="legal-section">
        <h2>八、隐私保护</h2>
        <p>
          我们高度重视用户个人信息保护，相关规则详见本网站《隐私政策》。本声明与《隐私政策》就个人信息处理事项存在不一致的，以《隐私政策》为准。
        </p>
      </section>

      <section class="legal-section">
        <h2>九、声明的更新与法律适用</h2>
        <p>
          9.1
          我们有权根据法律法规的变化及网站运营需要修改本声明，修改后的声明将在本网站显著位置公示，公示后即生效。请您定期查看；您继续访问、使用本网站的，视为同意修改后的声明。
        </p>
        <p>
          9.2
          本声明的成立、生效、履行、解释及争议解决，均适用中华人民共和国法律（为本声明之目的，不含香港特别行政区、澳门特别行政区及台湾地区法律）。
        </p>
        <p>
          9.3
          您与我们就本声明发生争议的，应首先友好协商解决；协商不成的，任何一方均有权向本公司住所地有管辖权的人民法院提起诉讼。
        </p>
        <p>
          9.4
          本声明部分条款被认定为无效的，不影响其他条款的效力。本声明未尽事宜，依照相关法律法规执行。
        </p>
      </section>

      <section class="legal-section">
        <h2>十、联系方式</h2>
        <p>
          如您对本声明有任何疑问、异议，或需要反馈知识产权、侵权相关问题，请通过下列方式与我们联系：
        </p>
        <ul>
          <li>联系部门：法务部 / 品牌市场部</li>
          <li>联系电话：028-86533354</li>
          <li>电子邮箱：xiaomanguanjia@smalleel.com</li>
          <li>联系地址：四川省成都市双流区电子科大科技园（天府园区）B12栋4单元5楼</li>
          <li>在线渠道：本网站"联系我们""意见反馈"功能</li>
        </ul>
      </section>

      <div class="legal-footer">
        <p>辰鳗科技集团有限公司</p>
        <p>2026年8月24日</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "copyrightPage",
  mounted() {
    document.title = "版权声明-辰鳗科技集团-小鳗管家";
  },
};
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 0 80px;
  overflow-y: auto;
}
.legal-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px 60px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.breadcrumb-bar {
  font-size: 14px;
  color: #969fa6;
  margin-bottom: 24px;
}
.crumb {
  cursor: pointer;
  color: #3170ff;
}
.crumb:hover {
  text-decoration: underline;
}
.sep {
  margin: 0 8px;
  color: #c0c4cc;
}
.crumb-current {
  color: #606266;
}
.legal-title {
  font-size: 28px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 8px;
  text-align: center;
}
.legal-updated {
  text-align: center;
  color: #969fa6;
  font-size: 13px;
  margin-bottom: 40px;
}
.legal-section {
  margin-bottom: 32px;
  text-align: left;
}
.legal-intro {
  margin-bottom: 16px;
}
.legal-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 12px;
  padding-left: 12px;
  border-left: 3px solid #3170ff;
}
.legal-section p {
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
  margin: 8px 0;
}
.legal-section ul {
  padding-left: 24px;
  margin: 8px 0;
}
.legal-section li {
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
  margin-bottom: 4px;
}
.legal-footer {
  text-align: center;
  color: #969fa6;
  font-size: 14px;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #ebeef5;
}
.legal-footer p {
  margin: 4px 0;
}
@media (max-width: 768px) {
  .legal-container {
    padding: 24px 20px;
  }
  .legal-title {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/copyright.vue